import StatementStatistic from "/src/features/dataset/components/table/StatementTable/StatementStatistic";

function StatementStatistics() {
    
    return <StatementStatistic/>
}

export default StatementStatistics;